import { render } from "./ServicesForm.vue?vue&type=template&id=d237fc62"
import script from "./ServicesForm.vue?vue&type=script&lang=js"
export * from "./ServicesForm.vue?vue&type=script&lang=js"

import "./ServicesForm.vue?vue&type=style&index=0&id=d237fc62&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__